import TopBannerMobile from './TopBannerMobile';
import TopBannerDesktop from './TopBannerDesktop';
import { useIsMobile } from '../../../utils/isMobile';

interface TopBannerProps {
  onClose: () => void;
}

export default function TopBanner({ onClose }: TopBannerProps) {
  const isMobile = useIsMobile();

  return isMobile
    ? <TopBannerMobile onClose={onClose} />
    : <TopBannerDesktop onClose={onClose} />;
}
